import { render, staticRenderFns } from "./PatientTreatmentDetail.vue?vue&type=template&id=7691ca79&scoped=true&lang=pug"
import script from "./PatientTreatmentDetail.vue?vue&type=script&lang=js"
export * from "./PatientTreatmentDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientTreatmentDetail.vue?vue&type=style&index=0&id=7691ca79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7691ca79",
  null
  
)

export default component.exports